import { guardNumber } from "@msuite/utils/numbers";
import type { Nullable } from "@msuite/utils/types";

/** Props Interface */
interface StatsValuesProps {
	children: Nullable<number | string>;
	forceNumber?: boolean;
}

export function StatsValue({ children, forceNumber = true }: StatsValuesProps) {
	/** Guard */
	const value = forceNumber ? guardNumber(children) : children;

	/** Render */
	return <p className="font-bold text-2xl">{value}</p>;
}
